module.exports = require("./ar-MA.d.ts");